import { INSTRUMENT_DOI_SUFFIX_PREFIX } from '../constants';

// Instrument DOIs (suffix ESRF-INSTR-*) are never indexed in ICAT+, so this
// lets callers skip that lookup entirely instead of waiting on it to fail.
export function isInstrumentDOI(doi: string): boolean {
  return doi.includes(INSTRUMENT_DOI_SUFFIX_PREFIX);
}

export interface DOI {
  doi: string;
  title: string;
  creators?: DOIParticipant[];
  contributors?: DOIParticipant[];
  publicationYear?: number;
  instruments: string[];
  proposals: string[];
  description?: string;
  publisher?: string;
  collectionDate?: string;
  releaseDate?: string;
  categories?: string[];
  relatedDOI: string[];
  resourceType?: string;
  resourceTypeGeneral?: string;
  aliases?: string[];
  operationalPeriod?: string;
  techniques?: DOIControlledTerm[];
  classifications?: DOIControlledTerm[];
  location?: string;
  createdDate?: string;
  keywords?: string[];
  citationPublicationDOI?: string;
  referenceURLs: string[];
  rights?: Rights;
  owners?: DOIOwner[];
  describedByDOIs: string[];
  isNewVersionOfDOI?: string;
  isPreviousVersionOfDOI?: string;
}
export interface DOIParticipant {
  name: string;
  orcid?: string;
  ror?: string;
  contributorType?: string;
}

export interface DOIControlledTerm {
  name: string;
  uri?: string;
  scheme?: string;
}

export interface DOIOwner {
  name: string;
  ror?: string;
  location?: string;
}

interface Rights {
  rights: string;
  rightsURI: string;
}
